import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import AboutContent from "../components/AboutContent";
import Footer from "../components/Footer";
import SkillsContent from "../components/SkillsContent";

const About = () => {
  return (
    <div>
      <NavBar />
      {/* <HeroImage2
        bgImage="hero-img-about"
        heading="PROFESSIONAL SUMMARY"
        text="As a Computer Engineering graduate with over 5 years of experience, I have developed a broad
        range of skills in software development, project management, and team leadership. My
        extensive knowledge of programming languages, database management systems, and software
        development methodologies enables me to create innovative and effective solutions. I am a
        
        strategic thinker with a proven track record of delivering projects on time while ensuring high-quality results."
      /> */}
      {/* <SkillsContent /> */}
      <AboutContent />
      {/* <Footer /> */}
    </div>
  );
};

export default About;
